import Sidebar from '@Components/Sidebar'
import Navbar from '@Components/navbar'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useDisconnectIGMutation, useLazyGetChannelsQuery } from './apiSlice'
import { Avatar } from '@assets/index'

import ReactModal from 'react-modal';
import styles from './styles'
import { ROUTES } from '@Constants/routes'
import { useLazyGetProfileQuery } from '@Pages/Profile/apiSlice'
import posthog from 'posthog-js'
import { AnalyticsParamBuilder, clientId, redirectPath, responseType, scope } from "@Utils/common";


const COMPONENT = "instagram_accounts"

const Channels = () => {

  const [disconnectModal, setDisconnectModal] = useState(false)
  const [disconnectChannelData, setDisconnectChannelData] = useState({
    igpid: '-1',
    ig_id: '-1',
    ig_username: ''
  })


  const navigate = useNavigate();

  const [getChannels, { data: channelsData, isLoading: isChannelsLoading }] = useLazyGetChannelsQuery()

  const [getProfile, { data: getProfileDataResponse }] = useLazyGetProfileQuery();

  const closeDisconnectModal = () => {
    posthog.capture("ui_action", AnalyticsParamBuilder({
      kingdom: COMPONENT,
      phylum: "cancel_disconnect_ig_account",
      classValue: disconnectChannelData?.ig_id,
      genus: disconnectChannelData?.ig_username,
      int_value: Number(disconnectChannelData?.igpid),
    }));
    setDisconnectModal(!disconnectModal)
  }

  useEffect(() => {
    getChannels({})
  }, [])

  useEffect(() => {
    getProfile({})
  }, [channelsData])

  const onDisconnectBtnClick = (ig_app_id: string, ig_id: string, ig_username: string) => {
    posthog.capture("ui_action", AnalyticsParamBuilder({
      kingdom: COMPONENT,
      phylum: "disconnect_ig_account",
      classValue: ig_id,
      genus: ig_username,
      int_value: Number(ig_app_id),
    }));
    posthog.capture("ui_view", AnalyticsParamBuilder({
      kingdom: COMPONENT,
      phylum: "modal",
      classValue: "disconnect_ig_account",
      genus: ig_id,
      str_value: ig_username,
      int_value: Number(ig_app_id),
    }));
    setDisconnectModal(true)
    setDisconnectChannelData({
      igpid: ig_app_id,
      ig_id,
      ig_username
    })
  }

  const refreshChannelData = () => {
    getChannels({})
  }



  const handelRefreshButtonClick = (ig_username: string, ig_id: string, ig_app_id: string) => {
    posthog.capture("ui_action", AnalyticsParamBuilder({
      kingdom: COMPONENT,
      phylum: "refresh_ig_token",
      classValue: ig_id,
      genus: ig_username,
      int_value: Number(ig_app_id),
    }));

    // Construct the redirect URL dynamically using the current origin
    const redirectUri = `${window.location.origin}${redirectPath}`;

    const authUrl = `https://www.instagram.com/oauth/authorize?force_reauth=true&client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=${responseType}&scope=${encodeURIComponent(scope)}`;

    // console.log(redirectUri)
    // Redirect the user to the dynamically constructed URL
    window.location.href = authUrl;
  }



  return (
    <div>
      <div className='flex'>
        <div className='w-full'>
          {/* <div className='p-8 border-b-2 flex place-content-between '>
            <h1 className='text-2xl font-bold'>Channels</h1>
            {channelsData && channelsData?.channel.instagram.length<=0
            ?
            <button className='bg-[#887DF2] text-white px-5 rounded-lg py-3'
                onClick={(e) => navigate(ROUTES.IG_CONNECT)}>Add Channel</button>
            :
            <></>}
          </div> */}
          <div className='flex flex-row gap-4 p-8'>
            {channelsData && channelsData?.channel?.instagram?.map((el: any, idx: number) => {
              return (
                <div className='max-w-[300px] w-full flex flex-col border-2 rounded-lg p-3'>
                  <div className='p-2'>
                    <img className='w-[100px] mx-auto rounded-full' src={el.profile_picture_url} />
                  </div>
                  <div className='p-3 w-full text-center'>
                    <p className='text-xl font-bold'>{el.username}</p>
                    <p className='text'>{el.name}</p>
                    <button className="px-6 py-1 w-full mt-2 border-solid rounded bg-[#ef4444] hover:bg-[#dc2626] text-white" onClick={() => onDisconnectBtnClick(el.instagram_id, el.igsid, el.username)}>Disconnect</button>
                    <button className="px-6 py-1 w-full mt-2 border-solid rounded bg-green-500 hover:bg-green-600 text-white" onClick={() => handelRefreshButtonClick(el.username, el.igsid, el.instagram_id)}>Refresh Token</button>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
      <DeleteAutomationModal isModalOpen={disconnectModal} disconnectModalOnClose={closeDisconnectModal} disconnectChannelData={disconnectChannelData} refreshChannel={refreshChannelData} />
    </div>
  )
}



interface DeleteAutomationModalInterface {
  isModalOpen: boolean;
  disconnectModalOnClose: () => void;
  disconnectChannelData: any
  refreshChannel: () => void;
}


const DeleteAutomationModal = (props: DeleteAutomationModalInterface) => {

  const [disconnectIG, { data: disconnectIGData, error: disconnectIGErr, isLoading: isDisconnectIGLoading }] = useDisconnectIGMutation()


  useEffect(() => {
    if (disconnectIGData) {
      props.disconnectModalOnClose()
      props.refreshChannel()
    }
    if (disconnectIGErr) console.log(disconnectIGErr);
  }, [disconnectIGData, disconnectIGErr])

  const disconnectBtnClick = (e: any) => {
    posthog.capture("ui_action", AnalyticsParamBuilder({
      kingdom: COMPONENT,
      phylum: "confirm_disconnect_ig_account",
      classValue: props.disconnectChannelData?.ig_id,
      genus: props.disconnectChannelData?.ig_username,
      int_value: Number(props.disconnectChannelData?.igpid),
    }));

    disconnectIG(props.disconnectChannelData)
  }


  return (
    <ReactModal
      isOpen={props.isModalOpen}
      onRequestClose={props.disconnectModalOnClose}
      style={
        { overlay: {}, content: styles.deleteContactModalContent }
      }
      portalClassName={"ReactModalPortal"}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      role={"dialog"}
      preventScroll={false}
    >
      <>
        <div className="pb-[.5rem] border-b-2 border-slate-300" style={styles.modalHeader}>
          <h3>Confirm</h3>
        </div>
        <div className="py-[1rem]" style={styles.modalContent}>
          <p>Are you sure to disconnect this channel?</p>
          <div className="flex justify-end mt-[2rem]">
            <button className="px-6 py-1 border-2 border-solid rounded" style={styles.redButton} onClick={disconnectBtnClick} disabled={isDisconnectIGLoading}>Disconnect</button>
            <button
              className="px-6 py-1 border-2 border-solid rounded border-green-500 mx-2 w-[150px]"
              style={styles.greenButton}
              onClick={props.disconnectModalOnClose}>
              Cancel
            </button>
          </div>
        </div>
      </>
    </ReactModal>
  )
}

export default Channels